<template>
  <div>
    <Header title="Statistics" subtitle="For all the numbers" />
    <ApplicantStats />
  </div>
</template>

<script>
  import Header from '../../../containers/Header';
  import ApplicantStats from './ApplicantStats';
  import SystemStatus from './SystemStatus';

  export default {
  name: 'Home',
  components: {
    ApplicantStats,
    SystemStatus,
    Header,
  },
};
</script>

<style src="./Stats.module.scss" lang="scss" module />
